export const VNDataBridgeReceiveType = {
  IOS_QR_CODE: 'IOS_QR_CODE',
  REQUEST_LOCATION: 'REQUEST_LOCATION',
  SDK_PAYMENT_REQUEST: 'SDK_PAYMENT_REQUEST',
  SDK_GO_BACK: 'SDK_GO_BACK',
  IOS_I4GO_APPLE_PAY_RECEIPT_ID: 'IOS_I4GO_APPLE_PAY_RECEIPT_ID'
}

export default VNDataBridgeReceiveType
